<template>
  <el-popover
    v-model="isShowPicker"
    placement="top"
    :width="240"
    trigger="click"
    popper-class="high-zindex-color-picker"
    :append-to-body="appendToBody"
  >
    <template #reference>
      <div class="color-picker-box-new">
        <div class="color-picker-box-container">
          <div v-if="isShowAdd" class="border color-inner">
            +
          </div>
          <div
            v-else
            ref="colorsure"
            class="border color-inner"
            :style="{ 
              background: `#${colorValue}`,
              border: needBorder ? `3px solid #2589ff` : 'none'
            }"
            :title="$t('deviceMsg.colorCustomize')"
          >
            <img src="~@/assets/img/cunstom_edit.png" class="cunstom_edit">
          </div>
          <div v-if="needBorder" class="color-name" :title="$t('deviceMsg.colorCustomize')">
            {{ $t('deviceMsg.colorCustomize') }}
          </div>
        </div>
      </div>
    </template>
    <div class="color-picker-main">
      <div class="color-picker-main-rgb">
        <el-input
          v-model="hexColorValue"
          size="small"
          :controls="false"
          @change="val => changeHex(val)"
        />
        <OppleButton
          class="color-picker-main_reset"
          size="mini"
          @mousedown.native="prepareSkipChange"
          @click="sure"
        >
          {{ $t('deviceMsg.sure') }}
        </OppleButton>
        <!-- <div>
          R: <el-input-number
            v-model="rgbValue.r"
            size="small"
            :controls="false"
            :min="0"
            :max="255"
            @change="val => changeRgb('r', val)"
          />
        </div>
        <div>
          G: <el-input-number
            v-model="rgbValue.g"
            size="small"
            :controls="false"
            :min="0"
            :max="255"
            @change="val => changeRgb('g', val)"
          />
        </div>
        <div>
          B: <el-input-number
            v-model="rgbValue.b"
            size="small"
            :controls="false"
            :min="0"
            :max="255"
            @change="val => changeRgb('b', val)"
          />
        </div> -->
      </div>
      <div :id="`pick_color-${randomId}`" />
    </div>
  </el-popover>
</template>

<script>
import iro from '@jaames/iro';
import { v4 as uuid } from "uuid";
import OppleButton from '@/components/Base/OppleButton/index.vue'

export default {
  components: {
    OppleButton
  },
  props: {
    index: {
      type: Number,
      default: 0,
    },
    colorValue: {
      type: String,
      default: '',
      required: true,
    },
    model: {
      type: Object,
      Default: {},
      required: true,
    },
    needBorder: {
      type: Boolean,
      Default: false,
    }
  },
  data() {
    return {
      isFirstRender: true,
      randomId: '',
      colorPicker: null,
      isShowPicker: false,
      displayedColor: false,
      rgbValue: { r: 0, g: 0, b: 0 },
      hexColorValue: '',
      isChecked: false,
      appendToBody: true,
    }
  },
  computed: {
    isCustom() {
      if (!this.colorValue) return true;

      if (!!this.model.EnumValue.find(item => item.Value === this.colorValue)) return false;

      return true;
    },
    isShowAdd() {
      if (this.colorValue === '000000') return true;
      if (!this.colorValue) return true;

      // 有颜色 但是不在默认颜色中
      if (!this.model.EnumValue.find(item => item.Value === this.colorValue)) return false;

      return true;
    }
  },
  watch: {
    isShowPicker(val) {
      if (!!val && this.isFirstRender) {
          const colorPicker = new iro.ColorPicker(`#pick_color-${this.randomId}`, {
            width: 190,
            color: this.hexColorValue
          });

          this.colorPicker = colorPicker;
          this.isFirstRender = false;

          colorPicker.on('color:change', this.colorChange);
        // }, 1000);
      }

      // if (!val) {
      //   debugger
      //   this.$emit('change', this.hexColorValue.substring(1));
      // }
      // console.log('val', val);
      
    },

     colorValue(val) {
      const color = this.transColor(val);

      if (color === this.hexColorValue) return;

      this.hexColorValue = color;
      // this.$nextTick(() => {
      //   debugger
      //   this.colorPicker.color.hexString = color;
      //   this.hexColorValue = color;
      // })
      
      // if (this.isFirstRender) return;
      // this.hexColorValue = val;
    }
  },
  mounted() {
    // el-popover必须挂到 body：在场景页里若 append-to-body=false，popover 落在局部 DOM 树里，
    // 会与父级的 stacking context（transform/overflow/fix 定位层）打架，再高 z-index 也盖不住外层兄弟节点。
    this.randomId = uuid();
    const color = this.transColor(this.colorValue);
    
    this.hexColorValue = color;
    // this.$emit('change', color);

    // this.$nextTick(() => {
      // const colorPicker = new iro.ColorPicker(`#pick_color-${this.randomId}`, {
      //   width: 190,
      //   color
      // });

      // this.colorPicker = colorPicker;
      // this.colorPicker.color.hexString = color;
      // this.hexColorValue = color;

      // setTimeout(() => {
      //   colorPicker.on('color:change', this.colorChange);
      // },1500);
    // });
  },
  methods: {
    transColor(val) {
      return  val && val !== '000000' ? `${val.startsWith('#') ? '' : '#'}${val}` : '#ffffff';
    },
    _rgbToHex({ r, g, b }){
      return '#' + [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('');
    },
    _hsvToRgb(h, s, v){
      const c = v * s;
      const x = c * (1 - Math.abs((h / 60) % 2 - 1));
      const m = v - c;
      let r1, g1, b1;

      if (h < 60) [r1, g1, b1] = [c, x, 0];
      else if (h < 120) [r1, g1, b1] = [x, c, 0];
      else if (h < 180) [r1, g1, b1] = [0, c, x];
      else if (h < 240) [r1, g1, b1] = [0, x, c];
      else if (h < 300) [r1, g1, b1] = [x, 0, c];
      else [r1, g1, b1] = [c, 0, x];

      return {
        r: Math.round((r1 + m) * 255),
        g: Math.round((g1 + m) * 255),
        b: Math.round((b1 + m) * 255),
      }
    },
    _rgbToHsv(r, g, b){
      r /= 255;
      g /= 255;
      b /= 255;

      var max = Math.max(r, g, b);
      var min = Math.min(r, g, b);
      var delta = max - min;

      var h = 0;
      if (delta !== 0) {
        if (max === r) h = 60 * (((g - b) / delta) % 6);
        else if (max === g) h = 60 * ((b - r) / delta + 2);
        else h = 60 * ((r - g) / delta + 4);
      }
      if (h < 0) h += 360;

      var s = max === 0 ? 0 : delta / max;
      var v = max;

      return { h: h, s: s, v: v };
    },
    _hexToRgb(hex){
      hex = hex.replace(/^#/, '');
      if (hex.length === 3) {
        hex = hex.split('').map(c => c + c).join('');
      }
      const num = parseInt(hex, 16);
      return {
        r: (num >> 16) & 0xff,
        g: (num >> 8) & 0xff,
        b: num & 0xff
      };
    },
    fixColorToWheel(hex){
      let { r, g, b } = this._hexToRgb(hex);
      let { h, s, v } = this._rgbToHsv(r, g, b);

      // 黑色修正为圆盘边缘（S=0, V=1）
      if (v === 0) {
        return this._rgbToHex(this._hsvToRgb(h, 0, 1));
      }

      // 饱和度修正到 [0,1]
      if (s > 1) s = 1;
      if (s < 0) s = 0;

      // V 始终为 1
      v = 1;

      const fixedRgb = this._hsvToRgb(h, s, v);
      return this._rgbToHex(fixedRgb);
    },
    prepareSkipChange(){
      this.isChecked = true
    },
    sure(){
      this.isChecked = true
      const cleanColor = this.hexColorValue.trim().replace(/^#/, '');
      const isHex = /^([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(cleanColor);

      if (!isHex) {
        this.$message.error(this.$t('deviceMsg.validHexColor'));
        this.isChecked = false;
        return;
      }

      const fixColor = this.fixColorToWheel(this.hexColorValue);

      if((this.hexColorValue || '').toLocaleLowerCase() !== (fixColor || '').toLocaleLowerCase()) {
        this.$message.error(this.$t('deviceMsg.rangeOfTheColorPalette'));
      }

      this.hexColorValue = fixColor;
      this.colorPicker.color.hexString = fixColor;

      this.isChecked = false;
    },
    reset() {
      this.hexColorValue= '#ffffff';
      this.colorPicker.color.hexString = '#ffffff';
    },
    changeHex(color) { 
      if(this.isChecked){
        this.isChecked = false
        return;
      }
      const cleanColor = color.trim().replace(/^#/, '');
      const isHex = /^([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(cleanColor);

      if (!isHex) {
        this.$message.error(this.$t('deviceMsg.validHexColor'));
        return;
      }
      const fixColor = this.fixColorToWheel(color)
        
      if((color || '').toLocaleLowerCase() !== (fixColor || '').toLocaleLowerCase()) {
         this.$message.error(this.$t('deviceMsg.rangeOfTheColorPalette'));
      }

      this.hexColorValue = fixColor;
      this.colorPicker.color.hexString = fixColor;
    },
    changeRgb(key, val) {
      this.rgbValue[key] = val;
      this.colorPicker.color.rgb = this.rgbValue;
    },
    colorChange(data) {
      const value = data.hexString;
      let val = value.substring(1);

      if (val === '000000') val = '000001';

      this.hexColorValue = `#${val}`;
      // this.rgbValue = hexToRgb(value);
      this.$emit('change', val);
    },
  },
}
</script>

<style lang="scss" scoped>
.color-picker-box-container {
  width: 40px;
}
.color-picker-box-new {
  position: relative;
  z-index: 1002;
}
.color-picker-box {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999;
  background-color: red;

}

.color-inner {
  position: relative;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  z-index: 999;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #d8d8d8;
  margin: 0 auto;
  background-size: contain !important;

  span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: rotate(-50%, -50%);
  }
}

.checked {
    padding: 0;
    border: 3px solid #2589ff;
  }

  .border {
    border: 1px dashed #d8d8d8;
  }

  .color-item {
    margin-right: 10px;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-bottom: 10px;
  }

  .color-name {
    margin-top: 5px;
    // line-height: 20px;
    text-align: center;
    font-size: 12px;
    display: block;
    // height: 40px;
    // overflow: hidden;
  }

.color-list-box {
  flex: 1;
  
}

.color-list-box {
  display: flex;
  flex-wrap: wrap;
  //margin-left: -20px;
}
.cunstom_edit {
  position: absolute;
  top: -3px;
  right: -8px;
  width: 23px;
  height: 23px;
}
.color-picker-main {
  width: 190px;
  margin: 0 auto;
}

.color-picker-main-rgb {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-bottom: 10px;

  &>div {
    display: flex;
    align-items: center;
  }
}

.color-picker-main {
  &_reset {
    min-width: auto;
    padding: 7px 8px;
    border-radius: 0 4px 4px 0;
  }
}

</style>
<style>
.panel-box-top .el-input__inner {
  padding: 0 0;
  height: 20px !important;
  text-align: center;
}

.panel-box_new {
  background: #fff;
  padding: 5px;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.302);
  border-radius: 5px;
}
.panel-box_new .panel-box-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  height: 25px;
}
.panel-box_new .panel-input {
  width: 50px;
  height: 20px;
}

.panel-box_new .color-panel::before {
  display: none;
}

.high-zindex-color-picker {
  z-index: 9999 !important;
}

.IroSlider {
  display: none !important;
}

.color-picker-main-rgb .el-input-number--small {
  width: 50px;
  height: 26px;
}
.color-picker-main-rgb .el-input-number.is-without-controls .el-input__inner  {
  padding-left: 0;
  padding-right: 0;
  height: 26px;
  line-height: 26px;
  border-radius: 4px 0 0 4px;
}

</style>
